import * as moment from 'moment';


import {
  Input,
  OnInit,
  Inject,
  Component,
} from 'ng-metadata/core';

import creditCardHtml from './credit-card.html';
import { execFileSync } from 'child_process';

/**
 * Stripe elements credit card component
 */
@Component({
  selector: 'gwFormCreditCard',
  template: creditCardHtml,
})
export class FormCreditCardComponent implements OnInit {
  public expirationYears = [];
  public expirationMonths = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
  public creditCardForm;

  public cardIcon = 'default.svg';
  public cardTypeIcons = {
    Visa: 'visa.svg',
    Mastercard: 'mastercard.svg',
    'American Express': 'amex.svg',
    'Diners Club': 'diners.svg',
    Discover: 'discover.svg',
    JCB: 'jcb.svg',
    UnionPay: 'unionpay.svg',
    Maestro: 'maestro.svg',
    Elo: 'elo.svg',
  };

  @Input() card;

  constructor() {}


  /**
   * Component init hook
   */
  ngOnInit() {
    const yearsAmount = 10;
    const currentYear = moment();
    
    for (let i = 0; i < yearsAmount; i += 1) {
      this.expirationYears.push(currentYear.format('Y'));
      currentYear.add(1, 'year');
    }
  }

  getCreditCardIcon(cardType) {
    return this.cardTypeIcons[cardType] || 'default.svg';
  }

  expirationDate(){
        
    var flag = false;  

    switch(this.card.exp.month != undefined && this.card.exp.year != undefined){

      case this.card.exp.year > moment().year():
        flag = true;
        break;
      
      case this.card.exp.month <= moment().month() && this.card.exp.year <= moment().year():
        flag = false;
        break;
      
      case this.card.exp.month > moment().month() && this.card.exp.year <= moment().year():
        flag = true;
        break;

      default:
        flag = false;
        break;

    }

    this.creditCardForm.cc_exp_month.$setValidity( 'expirationCard' , flag);


  }

}



// WEBPACK FOOTER //
// ./resources/assets/js/common/forms/credit-card/credit-card.component.ts